import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { InputLabelProps } from './interfaces';

import useStyles from './style';

const InputLabel: FC<PropsWithChildren<InputLabelProps>> = ({
  className,
  text,
  required,
  disabled,
  children,
  view = 'vertical',
  iconPrefix = null,
}) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        'inputLabel',
        view,
        classes.inputLabel,
        { [classes.disabled]: disabled },
        className
      )}
    >
      <span className="text">
        {iconPrefix}
        {text}
        {required ? <span className={classNames('req', classes.req)}> *</span> : null}
      </span>
      {children}
    </div>
  );
};

export default InputLabel;
